import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';

/**
 * Auth0 redirect_uri target. Successful login is completed by Auth0Provider
 * onRedirectCallback (navigate to app). This page only handles OAuth errors
 * and failed / incomplete exchanges.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isLoading, isAuthenticated, error } = useAuth0();

  useEffect(() => {
    const oauthError = searchParams.get('error');
    if (oauthError) {
      navigate('/unauthorized', {
        replace: true,
        state: {
          message:
            searchParams.get('error_description')?.replace(/\+/g, ' ') ||
            oauthError,
        },
      });
    }
  }, [searchParams, navigate]);

  useEffect(() => {
    if (searchParams.get('error')) return;
    if (isLoading) return;
    if (error) {
      navigate('/unauthorized', {
        replace: true,
        state: { message: error.message },
      });
      return;
    }
    if (!isAuthenticated) {
      navigate('/unauthorized', {
        replace: true,
        state: { message: 'Sign-in was not completed.' },
      });
    }
  }, [isLoading, isAuthenticated, error, navigate, searchParams]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white dark:bg-gray-900">
      <p className="text-sm text-gray-600 dark:text-gray-400">
        Completing sign in…
      </p>
    </div>
  );
}
